import {useTranslation} from "react-i18next";
import { THEFT,  MISAPPROPRIATION,
} from "../../finessecurity/component/Constants";


export const useEventTypeValues = () => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});

    const getEventTypeValues = (status: number) => {
        switch (status) {
            case THEFT: return t('eventCard.theft');
            case MISAPPROPRIATION: return t('eventCard.misappropriation');

            default : return ''
        }
    };

    return {
        getEventTypeValues
    }
}